import React, { useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import { useForm } from 'utils/hooks/useForm';
// import moment from 'moment';
import 'moment/locale/es';
import { numberBetween, valueHasData } from 'utils/validationsHelper';
import { isNumber } from 'utils/math';
import { validateEmail, validatePhone } from 'utils/functions';
import moment from 'moment';
import FormAbove from './FormAbove';
import MaterialLines from './MaterialLines';
import FormBelow from './FormBelow';
import scrollToFirstError from './scrollToFirstError';

const Form = function (props) {
  const {
    controls,
    setNextStep,
    actions,
    classes,
    handleChange,
    handleRemoveMaterial,
    linesHasChanged,
    calculatedValues,
    currencyCode,
    setCurrencyCode,
    convertKardexValue,
    convertZcotValue,
    clientLookup,
  } = props;

  const { onChange, onSubmit, errors } = useForm(controls, null, {
    onChange: handleChange,
    validations: {
      clientCode: [
        {
          check: (value) => valueHasData(value) || valueHasData(controls.clientName),
          message: 'Debe ingresar un código de cliente si no ingresa la empresa. ',
        },
        {
          check: (value) => !Number.isNaN(Number(value.trim())),
          message: 'El código debe ser numérico. ',
        },
        {
          check: (value) => !(clientLookup.code === value && clientLookup.notFound),
          message: 'No existe un cliente con ese código. ',
        },
      ],
      clientName: [
        {
          check: (value) => valueHasData(value) || valueHasData(controls.clientCode),
          message: 'Debe ingresar un nombre de empresa si no ingresa el código de cliente. ',
        },
      ],
      startDate: [
        {
          check: (value) => value != null && moment(value).isValid(),
          message: 'Debe ingresar fecha inicial. ',
        },
      ],
      validityDays: [
        {
          check: (value) =>
            valueHasData(value) && Number.isInteger(Number(value)) && numberBetween(value, 1, 365),
          message: 'Debe ingresar la validez en días (entre 1 y 365). ',
        },
      ],
      materialLines: [
        {
          check: (value) => value?.length,
          message: 'Debe ingresar al menos un producto. ',
        },
        {
          check: (value) => value.every((row) => row?.name && row?.mgPerc && row?.volumeKg),
          message: 'Debe completar todos los campos de productos. ',
        },
        {
          check: (value) => value.every((row) => numberBetween(row?.mgPerc || 0, 1, 99)),
          message: 'MG% debe ser entre 1 y 99 ',
        },
      ],
      atn: [
        {
          check: (value) => valueHasData(value),
          message: 'Debe ingresar nombre contacto cliente. ',
        },
      ],
      paymentCondition: [
        {
          check: (value) => valueHasData(value),
          message: 'Debe ingresar la condición de pago. ',
        },
        {
          check: (value) => isNumber(value),
          message: 'Error inesperado en la opción seleccionada. Contacte al administrador. ',
        },
      ],
      email: [
        {
          check: (value) => valueHasData(value),
          message: 'Debe ingresar un correo. ',
        },
        {
          check: (value) => validateEmail(value),
          message: 'Correo inválido ',
        },
      ],
      phone: [
        {
          check: (value) => validatePhone(value),
          message: 'Teléfono no válido',
        },
      ],
    },
  });

  const formRef = useRef(null);
  // Previsualizar está al final del formulario y los campos con error suelen quedar fuera de la
  // pantalla. El scroll se hace en el efecto: los errores recién están en el DOM tras el render.
  const scrollPendingRef = useRef(false);

  useEffect(() => {
    if (!scrollPendingRef.current) return;
    scrollPendingRef.current = false;
    scrollToFirstError(formRef.current, errors);
  }, [errors]);

  const hasErrors = Object.values(errors).some((fieldErrors) => fieldErrors?.length > 0);

  const handleNext = () => {
    scrollPendingRef.current = true;
    onSubmit(setNextStep);
  };

  // Las tres secciones comparten ancho y separación, así sus bordes quedan alineados.
  return (
    <Stack ref={formRef} spacing={3}>
      <FormAbove
        controls={controls}
        actions={actions}
        classes={classes}
        onChange={onChange}
        errors={errors}
        clientLookup={clientLookup}
      />
      <MaterialLines
        linesHasChanged={linesHasChanged}
        controls={controls}
        classes={classes}
        actions={actions}
        onChangeMain={onChange}
        handleRemoveMaterial={handleRemoveMaterial}
        calculatedValues={calculatedValues}
        errorsMain={errors}
        currencyCode={currencyCode}
        setCurrencyCode={setCurrencyCode}
        convertKardexValue={convertKardexValue}
        convertZcotValue={convertZcotValue}
      />
      <FormBelow
        controls={controls}
        actions={actions}
        setNextStep={setNextStep}
        classes={classes}
        onChange={onChange}
        errors={errors}
        hasErrors={hasErrors}
        handleNext={handleNext}
      />
    </Stack>
  );
};

export default Form;
